import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=3fb3bd62&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=3fb3bd62&scoped=true&lang=scss&"
import style1 from "./banner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3bd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb3bd62')) {
      api.createRecord('3fb3bd62', component.options)
    } else {
      api.reload('3fb3bd62', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=3fb3bd62&scoped=true&", function () {
      api.rerender('3fb3bd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/banner.vue"
export default component.exports